'use client';

import { useTranslations } from 'next-intl';
import Card from '../Card';
import Divider from '../ui/Divider';

export default function NoPositionsCard() {
  const t = useTranslations('jobPositions');

  return (
    <Card
      fullHeight
      elevation={false}
      item={{ title: t('noResultTitle'), description: t('noResultSummary') }}>
      <Divider direction="horizontal" size="md" color="accent" />
      <Card.Body cx={{ mT: 'md', display: 'flex', rowGap: 'md' }}>
        <Card.Title variant="h5" medium hover={false} />
        <Card.Description />
      </Card.Body>
    </Card>
  );
}
